"use strict";

define('components/tabs',['components/ajax', 'history'], function(ajax) {

    var tabs = {

        init: function () {
            if ($('.tabs-wrapper').length > 0) {
                this.initPageTabs();
            }

            if ($('.tab-list a, .tab-list option').length > 0) {
                this.initSubTabs();
            }
        },

        initSubTabs: function () {
            var self = this;

            // Handle clicks on subtab list-group items
            $('.tab-list a').click(function(e) {
                // Prevent browser's default behavior
                e.preventDefault();

                // Ignore clicks on active and disabled items
                var clickedItem = $(this);
                if (clickedItem.hasClass('active') || clickedItem.hasClass('disabled')) {
                    return;
                }

                var activeItem = clickedItem.siblings('.active');
                var url = clickedItem.attr('href');
                var headingId = clickedItem.closest('.list-group').attr('id');
                var stateData = {
                    'component': 'tabs',
                    'clickedItem': clickedItem.attr('href'),
                    'activeItem': activeItem.attr('href'),
                    'headingId': headingId
                }
                History.pushState(stateData, document.title, url);
            });

            // Handle clicks on subtab select options (on mobile, subtabs as rendered as a <select>)
            $('select.tab-list').change(function(e) {
                var selectedOption = $(e.target.options[e.target.selectedIndex]);
                var stateData = {
                    'component': 'tabs',
                    'clickedItem': selectedOption.data('url'),
                }
                History.pushState(stateData, document.title, selectedOption.data('url'));
            });

            History.Adapter.bind(window,'statechange',function() {
                // Handle only state changes triggered by this component
                var state = History.getState();
                if (!state.data || !Object.prototype.hasOwnProperty.call(state.data, 'component') || state.data.component != 'tabs') {
                    return
                }

                var clickedItemHref = History.getState().data['clickedItem'];
                var activeItemHref = History.getState().data['activeItem'];
                var url = clickedItemHref;
                if (!url) {
                    url = History.getState().url;
                }

                // show the opaque overlay over the data portion of the subtab - removed on ajax completion.
                var overlay = $('.subtab-data .subtab-overlay');
                if (overlay.length > 0) {
                    overlay.removeClass('hidden');
                }

                var headingId = History.getState().data['headingId'];
                ajax(url, {
                    formData: null,
                    onSuccess: function(result) {
                        if (clickedItemHref) {
                            $('.tab-list a').removeClass('active');
                            var clickedItem = $('a[href="' + clickedItemHref + '"]');
                            clickedItem.addClass('active');

                            var clickedItemHeading = clickedItem.closest('.list-group');
                            clickedItemHeading.siblings('h5').addClass('text-muted');
                            clickedItemHeading.siblings('h5[data-id="' + headingId + '"]').removeClass('text-muted');
                        }
                        setTimeout(function(){
                            $('.tab-list').trigger('jsq:tabLoaded', [])
                        }, 1);
                        if(typeof window.__jsqRenderPillars__ === 'function') {
                            window.__jsqRenderPillars__();
                        }
                        overlay.addClass('hidden');
                    },
                    onFailure: function(result) {
                        overlay.addClass('hidden');
                    }
                }, 'json');
            });
        },

        initPageTabs: function () {
            var wrapper = $('.tabs-wrapper');
            var wrapperWidth = wrapper.outerWidth();
            var list = $('.tabs-wrapper > ul');
            var scrollLeft = $('.scroller-left');
            var scrollRight = $('.scroller-right');

            // Calculate the width of the list a the sum of widths of all list-items since the list
            // has a large min-width.
            var listWidth = 0;
            list.children('li').each(function(index) {
                if (!$(this).hasClass('action-menu')) {
                    listWidth += $(this).outerWidth();
                }
            });

            var setMinWidth = function () {
                if (wrapperWidth > listWidth) {
                    list.css('min-width', '');
                } else {
                    list.css('min-width', listWidth+2+'px');
                }
            };

            var setActionMenuVisibility = function () {
                $('.action-menu').show();
            };

            var getLeftPosition = function(){
                return list.position().left;
            };

            var getWidthOfHidden = function(){
                return listWidth - wrapperWidth + getLeftPosition() - 7;
            };

            var setScrollerVisibility = function(){
                if (getWidthOfHidden() > 14) {
                    scrollRight.show();
                }
                else {
                    scrollRight.hide();
                }

                if (wrapperWidth > listWidth) {
                    scrollRight.hide();
                }

                if (getLeftPosition()<0) {
                    wrapper.css('margin-left', '14px');
                    scrollLeft.show();
                }
                else {
                    wrapper.css('margin-left', '0px');
                    scrollLeft.hide();
                }
            };

            scrollLeft.click(function() {
                var leftPos = $('.tabs-wrapper').scrollLeft();
                $(".tabs-wrapper").animate({scrollLeft: leftPos - wrapperWidth}, 300);
            });

            scrollRight.click(function() {
                var leftPos = $('.tabs-wrapper').scrollLeft();
                $(".tabs-wrapper").animate({scrollLeft: leftPos + Math.min(wrapperWidth, getWidthOfHidden())}, 300);
            });

            setScrollerVisibility();
            setMinWidth();
            setActionMenuVisibility();

            $(window).on('resize',function(e){
                wrapperWidth = wrapper.outerWidth();
                setScrollerVisibility();
                setMinWidth();
                setActionMenuVisibility();
            });

            $('.tabs-wrapper').on('scroll', function() {
                setScrollerVisibility();
            });

            // Skip page tab scrolling behavior on mobile devices (action-menu is hidden via media query.)
            if ($('.tabs-wrapper li.action-menu').is(':visible')) {
                return;
            }

            // If the screen is large enough to accommodate the list, then no scrolling required.
            if (wrapperWidth > listWidth) {
                return;
            }

            // Scroll to the current active item
            var activeItem = list.find('li.active');
            var scrollPos = Math.min(activeItem.position().left - activeItem.outerWidth()/2, listWidth - activeItem.outerWidth());
            $(".tabs-wrapper").animate({scrollLeft: scrollPos}, 300);
        }
    };

    return tabs;
});

